/**
 * Require a deliberate size choice on every PDP.
 * Explicit variant URLs keep their requested selection. Multi-option products
 * stay locked until each size group has a deliberate choice.
 */
(function () {
  function init() {
    if (!document.body.classList.contains('product')) return;
    if (new URLSearchParams(window.location.search).has('variant')) return;

    var productInfo = document.querySelector('product-info[id^="MainProduct-"]');
    var picker = productInfo && productInfo.querySelector('variant-selects');
    if (!productInfo || !picker || picker.dataset.typhSizeChoiceInit === 'true') return;

    var initialSizeFieldsets = Array.from(picker.querySelectorAll('fieldset.product-form__input')).filter(function (fieldset) {
      var legend = fieldset.querySelector('.typh-sf-legend__text, legend');
      var input = fieldset.querySelector('input[type="radio"]');
      return /size/i.test(((legend && legend.textContent) || '') + ' ' + ((input && input.name) || ''));
    });
    if (!initialSizeFieldsets.length) return;

    var requiredGroups = initialSizeFieldsets.map(function (fieldset) {
      return fieldset.querySelector('input[type="radio"]').name;
    });
    var choices = {};
    var scheduled = false;

    picker.dataset.typhSizeChoiceInit = 'true';

    function currentPicker() {
      return productInfo.querySelector('variant-selects');
    }

    function applyChoices() {
      scheduled = false;
      var activePicker = currentPicker();
      if (!activePicker) return;

      requiredGroups.forEach(function (group) {
        var inputs = Array.from(activePicker.querySelectorAll('input[type="radio"]')).filter(function (input) {
          return input.name === group;
        });
        inputs.forEach(function (input) {
          input.checked = choices[group] === input.value;
          if (!input.checked) input.removeAttribute('checked');
        });
      });

      var complete = requiredGroups.every(function (group) {
        return Boolean(choices[group]);
      });
      if (complete) return;

      var submit = productInfo.querySelector('.product-form__submit');
      if (!submit) return;
      submit.disabled = true;
      var label = submit.querySelector(':scope > span');
      if (label && label.textContent.trim() !== 'SELECT SIZE') label.textContent = 'SELECT SIZE';
    }

    function scheduleApply() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(applyChoices);
    }

    productInfo.addEventListener('change', function (event) {
      var input = event.target.closest('input[type="radio"]');
      if (!input || requiredGroups.indexOf(input.name) === -1) return;
      choices[input.name] = input.value;
      scheduleApply();
    });

    new MutationObserver(scheduleApply).observe(productInfo, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled'],
    });

    applyChoices();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
